import React, { useEffect } from 'react';

import GameListTable from './GameListTable';
import { useGames } from '../../queries/games';

const GamesList = ({ filters, data, currentPage, perPage, queryLimit, setTotal, setPage, ...props }) => {
  const { data: currentRows, initialPage, total, status } = useGames(filters, { currentPage, perPage, queryLimit })

  useEffect(() => {
    setTotal(total);
    setPage(initialPage);
  }, [ initialPage, total, setTotal, setPage ])

  return <GameListTable
    filters={filters}
    currentRows={currentRows}
    loading={status}
    currentPage={currentPage}
    perPage={perPage}
    schedules={data?.schedules}
    {...props}
  />
}

export default GamesList;
